import { render, staticRenderFns } from "./_community.vue?vue&type=template&id=4660db56&"
import script from "./_community.vue?vue&type=script&lang=ts&"
export * from "./_community.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports